import { render } from "./RadiogroupRadio_tabs.vue?vue&type=template&id=2e0570c0"
import script from "./RadiogroupRadio_tabs.vue?vue&type=script&lang=js"
export * from "./RadiogroupRadio_tabs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__